module.exports = __webpack_public_path__ + "img/jacobus_04.e16df4d5.png";